import { commonNouns } from '../data/commonNouns';

// Function to get a seeded random number between 0 and 1
const seededRandom = (seed: number) => {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
};

// Function to get a random integer between min and max (inclusive) using seeded random
const seededRandomInt = (seed: number, min: number, max: number) => {
  return Math.floor(seededRandom(seed) * (max - min + 1)) + min;
};

// Get the day number (days since epoch)
const getDayNumber = () => {
  const now = new Date();
  const start = new Date(2024, 0, 1); // Start from January 1, 2024
  const diff = now.getTime() - start.getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24));
};

export const getDailyWords = (): [string, string] => {
  const dayNumber = getDayNumber();
  
  // Use the day number as seed to get consistent random numbers for each day
  const firstWordIndex = seededRandomInt(dayNumber, 0, commonNouns.length - 1);
  // Use a different seed for the second word to avoid potential correlations
  const secondWordIndex = seededRandomInt(dayNumber + 1000, 0, commonNouns.length - 1);
  
  // Make sure we don't get the same word twice
  if (firstWordIndex === secondWordIndex) {
    return [commonNouns[firstWordIndex], commonNouns[(secondWordIndex + 1) % commonNouns.length]];
  }
  
  return [commonNouns[firstWordIndex], commonNouns[secondWordIndex]];
}; 